import React from "react"
import Image from "./image"

const RedImage = ({ filename, alt }) => <Image filename={filename} alt={alt} className="image-filter red-filter"/>

export default RedImage
